import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import logoIcon from "../../../../public/logo.svg";
export default function FooterBrand() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src={logoIcon} alt={"\u0627\u06CC\u062F\u0647 \u0646\u0645\u0627"} width={104} height={104} className="h-20 w-auto sm:h-24 md:h-26" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-3 text-center md:text-right "><div className="flex items-center flex-col md:flex-row gap-6">{t0}<div className="flex flex-col justify-between"><h3 className="text-2xl font-bold text-white">ایده نما</h3><p className="text-base text-white/70 leading-7 max-w-md">ایده‌نما، پلتفرم تخصصی کسب‌وکار و مدیریت با محتوای آموزشی، فیلم، سریال، مستند و برنامه‌های کودک و نوجوان.</p></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}